import { render, staticRenderFns } from "./PerfilEmpresa.vue?vue&type=template&id=14e31b5d&"
import script from "./PerfilEmpresa.vue?vue&type=script&lang=js&"
export * from "./PerfilEmpresa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports